import React from 'react'
import clsx from 'clsx'
import { User } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ChipAutocomplete from '../../../../../atoms/ChipAutocomplete'

import { isUUID } from '@SonarCX/utilities'

const ClientSection = ({
  classes,
  canEdit,
  canAddClient,
  fullPage,
  clientObj,
  sendValues,
  newUserName,
  setNewUserName
}) => {
  const theme = useTheme()
  const disabled = React.useMemo(
    () => !canEdit || !canAddClient,
    [canEdit, canAddClient]
  )

  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        !fullPage && classes.container
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <User
          variant='Bulk'
          size={theme.size.base}
          color={theme.palette.primary.main}
        />
        CLIENT
      </span>

      <div
        className={clsx(
          classes.input,
          !clientObj && !newUserName && classes.upInput,
          classes.chipAvatar
        )}
      >
        <ChipAutocomplete
          placeholder={!disabled ? 'Type and Search...' : 'No assigned client'}
          value={clientObj?.id ?? newUserName}
          onChange={id => {
            if (!id) {
              sendValues(null, 'client')
              return
            }

            if (isUUID(id)) {
              sendValues(id, 'client')
            } else {
              setNewUserName(id)
            }
          }}
          single
          freeSolo
          disabled={disabled}
        />
      </div>
    </div>
  )
}
export default ClientSection
